var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 102.4,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 102.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 204.8,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 409.6,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 102.4
  })), /*#__PURE__*/React.createElement("rect", {
    y: 307.2,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 102.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M266.758,264.402c4.273-3.966,4.273-12.838,0-16.804L0,0v512L266.758,264.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M109.034,199.093l12.802,38.386l40.463,0.314c5.239,0.041,7.411,6.726,3.197,9.838l-32.551,24.037  l12.205,38.579c1.58,4.995-4.107,9.127-8.369,6.08l-32.92-23.53l-32.92,23.53c-4.262,3.046-9.949-1.085-8.369-6.08l12.205-38.579  l-32.551-24.037c-4.214-3.112-2.042-9.798,3.197-9.838l40.463-0.314l12.802-38.386C100.347,194.124,107.376,194.124,109.034,199.093  z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr);
export default __webpack_public_path__ + "static/media/PR.e8f7057913f6c2c6ff62868a363b0ef5.svg";
export { ForwardRef as ReactComponent };